import { LookupRowOptionSkeleton } from './LookupRowOptionSkeleton'

/** Loading state for the lookup row options list. */
export function LookupRowOptionsListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="flex w-full flex-col p-2 pt-1">
      <LookupRowOptionSkeleton count={count} />
    </div>
  )
}
